(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wall-planner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.ef-planner');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const params = new URLSearchParams(location.search);
    const mode = params.get('type') === 'canvas' ? 'canvas' : 'poster';
    const imageUrl = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="500" height="700" viewBox="0 0 500 700"><rect width="500" height="700" fill="#eee5d6"/><path d="M0 450Q100 300 250 430T500 350V700H0Z" fill="#879985"/><circle cx="345" cy="205" r="100" fill="#be8465"/><path d="M0 600Q180 440 330 580T500 540V700H0Z" fill="#354840"/></svg>');
    const productTitle = root.dataset.example;
    const storageKey = `elframes-planner-${mode}-v3`;
    const defaults = { wallWidth: 400, wallHeight: 260, active: 'a', selected: null, nextId: 1, grid: false, a: [], b: [] };
    let state;
    let drag = null;
    let toastTimer;

    const $ = (selector, scope = root) => scope.querySelector(selector);
    const $$ = (selector, scope = root) => [...scope.querySelectorAll(selector)];
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const currentItems = () => state[state.active];
    const selectedItem = () => currentItems().find((item) => item.id === state.selected);
    const wallFor = (key) => key === 'a' ? $('#ef-wall-a') : $('#ef-wall-b');

    try {
      const saved = JSON.parse(localStorage.getItem(storageKey));
      state = saved && Array.isArray(saved.a) && Array.isArray(saved.b) ? { ...defaults, ...saved, selected: null } : structuredClone(defaults);
    } catch (error) {
      state = structuredClone(defaults);
    }

    const save = () => { try { localStorage.setItem(storageKey, JSON.stringify({ ...state, selected: null })); } catch (error) {} };
    const modeLabel = mode === 'canvas' ? root.dataset.canvasLabel : root.dataset.posterLabel;
    $('#ef-planner-mode').textContent = `${$('#ef-planner-mode').textContent.split('•')[0].trim()} • ${modeLabel}`;

    const productCard = $('#ef-planner-product');
    if (imageUrl) {
      productCard.hidden = false;
      $('#ef-planner-product-image').src = imageUrl;
      $('#ef-planner-product-image').alt = productTitle;
      $('#ef-planner-product-title').textContent = productTitle;
    }

    const sizeSource = mode === 'canvas' ? root.dataset.canvasSizes : root.dataset.posterSizes;
    sizeSource.split(',').forEach((size) => {
      const [width, height] = size.split('x').map(Number);
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.size = `${width},${height}`;
      button.textContent = `${width} × ${height} ${root.dataset.cm}`;
      $('#ef-planner-sizes').appendChild(button);
    });

    function showToast(message) {
      const toast = $('#ef-toast');
      toast.textContent = message;
      toast.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2000);
    }

    function overlaps(items) {
      const result = new Set();
      for (let i = 0; i < items.length; i += 1) {
        for (let j = i + 1; j < items.length; j += 1) {
          const a = items[i];
          const b = items[j];
          if (a.x < b.x + b.width && a.x + a.width > b.x && a.y < b.y + b.height && a.y + a.height > b.y) {
            result.add(a.id);
            result.add(b.id);
          }
        }
      }
      return result;
    }

    function addItem(width, height) {
      const offset = (currentItems().length % 5) * 5;
      const item = {
        id: state.nextId,
        width,
        height,
        x: clamp((state.wallWidth - width) / 2 + offset, 0, state.wallWidth - width),
        y: clamp((state.wallHeight - height) / 2 + offset, 0, state.wallHeight - height),
        frame: mode === 'canvas' ? 'none' : 'black',
        image: imageUrl
      };
      state.nextId += 1;
      currentItems().push(item);
      state.selected = item.id;
      save();
      render();
      showToast(root.dataset.added.replace('__SIZE__', `${width} × ${height}`));
    }

    function renderSelection() {
      const item = selectedItem();
      $('#ef-selection-empty').hidden = Boolean(item);
      $('#ef-selection-tools').hidden = !item;
      if (!item) return;
      $('#ef-selection-size').textContent = `${item.width} × ${item.height} ${root.dataset.cm}`;
      $$('#ef-frame-options button').forEach((button) => button.classList.toggle('is-active', button.dataset.frame === item.frame));
    }

    function renderWall(key) {
      const wall = wallFor(key);
      wall.style.setProperty('--wall-ratio', String(state.wallWidth / state.wallHeight));
      wall.classList.toggle('is-grid', state.grid);
      $$('.ef-art', wall).forEach((element) => element.remove());
      const overlapping = overlaps(state[key]);

      state[key].forEach((item) => {
        item.x = clamp(item.x, 0, Math.max(0, state.wallWidth - item.width));
        item.y = clamp(item.y, 0, Math.max(0, state.wallHeight - item.height));
        const element = document.createElement('div');
        element.className = `ef-art${key === state.active && item.id === state.selected ? ' is-selected' : ''}${overlapping.has(item.id) ? ' is-overlap' : ''}`;
        element.dataset.id = item.id;
        element.dataset.frame = item.frame;
        element.tabIndex = 0;
        element.style.left = `${item.x / state.wallWidth * 100}%`;
        element.style.top = `${item.y / state.wallHeight * 100}%`;
        element.style.width = `${item.width / state.wallWidth * 100}%`;
        element.style.height = `${item.height / state.wallHeight * 100}%`;
        const frame = document.createElement('div');
        frame.className = 'ef-art__frame';
        const image = document.createElement('img');
        image.className = 'ef-art__image';
        image.alt = '';
        image.src = imageUrl;
        image.draggable = false;
        element.setAttribute('role', 'button');
        element.setAttribute('aria-label', `${item.width} × ${item.height} ${root.dataset.cm}`);
        frame.appendChild(image);
        element.appendChild(frame);
        element.addEventListener('pointerdown', (event) => startDrag(event, key, item.id));
        element.addEventListener('click', (event) => {
          event.stopPropagation();
          state.active = key;
          state.selected = item.id;
          render();
        });
        element.addEventListener('keydown', (event) => nudge(event, key, item.id));
        wall.appendChild(element);
      });

      const card = $(`[data-composition="${key}"]`);
      $('footer span', card).textContent = String(state[key].length);
      $('.ef-planner__measure-x', card).textContent = `${state.wallWidth} ${root.dataset.cm}`;
      $('.ef-planner__measure-y', card).textContent = `${state.wallHeight} ${root.dataset.cm}`;
      const status = $('.ef-planner__status', card);
      status.classList.remove('is-valid', 'is-warning');
      if (!state[key].length) $('span', status).textContent = root.dataset.empty;
      else if (overlapping.size) {
        status.classList.add('is-warning');
        $('span', status).textContent = root.dataset.overlap;
      } else {
        status.classList.add('is-valid');
        $('span', status).textContent = root.dataset.valid;
      }
    }

    function render() {
      $('#ef-wall-width').value = state.wallWidth;
      $('#ef-wall-height').value = state.wallHeight;
      $$('.ef-planner__tabs button').forEach((button) => {
        const active = button.dataset.target === state.active;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      $$('.ef-planner__card').forEach((card) => card.classList.toggle('is-active', card.dataset.composition === state.active));
      $('#ef-copy').textContent = state.active === 'a' ? root.dataset.copyAB : root.dataset.copyBA;
      $('#ef-grid').setAttribute('aria-pressed', String(state.grid));
      renderWall('a');
      renderWall('b');
      renderSelection();
    }

    function startDrag(event, key, id) {
      event.preventDefault();
      event.stopPropagation();
      state.active = key;
      state.selected = id;
      const item = state[key].find((entry) => entry.id === id);
      drag = { key, id, startX: event.clientX, startY: event.clientY, itemX: item.x, itemY: item.y };
      event.currentTarget.setPointerCapture?.(event.pointerId);
      document.addEventListener('pointermove', moveDrag);
      document.addEventListener('pointerup', endDrag, { once: true });
      renderSelection();
    }

    function moveDrag(event) {
      if (!drag) return;
      const item = state[drag.key].find((entry) => entry.id === drag.id);
      const bounds = wallFor(drag.key).getBoundingClientRect();
      item.x = clamp(drag.itemX + (event.clientX - drag.startX) / bounds.width * state.wallWidth, 0, state.wallWidth - item.width);
      item.y = clamp(drag.itemY + (event.clientY - drag.startY) / bounds.height * state.wallHeight, 0, state.wallHeight - item.height);
      renderWall(drag.key);
    }

    function endDrag() {
      document.removeEventListener('pointermove', moveDrag);
      drag = null;
      save();
      render();
    }

    function nudge(event, key, id) {
      const moves = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] };
      if (!moves[event.key]) return;
      event.preventDefault();
      state.active = key;
      state.selected = id;
      const item = state[key].find((entry) => entry.id === id);
      const step = event.shiftKey ? 5 : 1;
      item.x = clamp(item.x + moves[event.key][0] * step, 0, state.wallWidth - item.width);
      item.y = clamp(item.y + moves[event.key][1] * step, 0, state.wallHeight - item.height);
      save();
      render();
    }

    function updateWall() {
      state.wallWidth = clamp(Number($('#ef-wall-width').value) || 400, 120, 1000);
      state.wallHeight = clamp(Number($('#ef-wall-height').value) || 260, 120, 500);
      save();
      render();
    }

    $('#ef-planner-sizes').addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button) return;
      addItem(...button.dataset.size.split(',').map(Number));
    });
    $$('.ef-planner__tabs button').forEach((button) => button.addEventListener('click', () => {
      state.active = button.dataset.target;
      state.selected = null;
      save();
      render();
    }));
    ['#ef-wall-width', '#ef-wall-height'].forEach((selector) => $(selector).addEventListener('change', updateWall));
    $('#ef-frame-options').addEventListener('click', (event) => {
      const button = event.target.closest('button');
      const item = selectedItem();
      if (!button || !item) return;
      item.frame = button.dataset.frame;
      save();
      render();
    });
    $('#ef-rotate').addEventListener('click', () => {
      const item = selectedItem();
      if (!item) return;
      [item.width, item.height] = [item.height, item.width];
      save();
      render();
    });
    $('#ef-duplicate').addEventListener('click', () => {
      const item = selectedItem();
      if (!item) return;
      const copy = { ...item, id: state.nextId, x: clamp(item.x + 8, 0, state.wallWidth - item.width), y: clamp(item.y + 8, 0, state.wallHeight - item.height) };
      state.nextId += 1;
      currentItems().push(copy);
      state.selected = copy.id;
      save();
      render();
    });
    $('#ef-delete').addEventListener('click', () => {
      if (!state.selected) return;
      state[state.active] = currentItems().filter((item) => item.id !== state.selected);
      state.selected = null;
      save();
      render();
    });
    $('#ef-copy').addEventListener('click', () => {
      const target = state.active === 'a' ? 'b' : 'a';
      state[target] = state[state.active].map((item) => ({ ...item, id: state.nextId++ }));
      save();
      render();
    });
    $('#ef-grid').addEventListener('click', () => {
      state.grid = !state.grid;
      save();
      render();
    });
    $$('[data-clear]').forEach((button) => button.addEventListener('click', () => {
      state[button.dataset.clear] = [];
      if (state.active === button.dataset.clear) state.selected = null;
      save();
      render();
    }));
    $$('.ef-planner__card').forEach((card) => card.addEventListener('pointerdown', (event) => {
      if (!event.target.closest('.ef-art') && !event.target.closest('button')) {
        state.active = card.dataset.composition;
        state.selected = null;
        save();
        render();
      }
    }));

    render();
    if (params.has('product') || params.has('size')) {
      const available = sizeSource.split(',').map((value) => value.split('x').map(Number));
      let dimensions = (params.get('size') || '').split('x').map(Number);
      if (!available.some(([w,h]) => (w === dimensions[0] && h === dimensions[1]) || (h === dimensions[0] && w === dimensions[1]))) dimensions = available[1];
      addItem(...dimensions);
      if (['black','white','none'].includes(params.get('frame'))) selectedItem().frame = params.get('frame');
      save(); render();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
